import React from 'react';

const WA_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '642040136241';

const included = [
  '3 hours of home cleaning (split across the week or in one block — your call)',
  '3 hours of pet care (walks, drop-offs, mid-day check-ins)',
  '1 hour of errands (grocery run, pharmacy, post office)',
];

const customise = [
  'Childcare',
  'House check-ins while you\'re away',
  'Calendar and appointment management',
  'Tradesperson coordination and wait-ins',
  'Travel research and booking',
  'Inbox triage and document organisation',
  'Reminders and accountability check-ins',
];

export default function WeeklyPA() {
  const waMsg = encodeURIComponent("Hi! I'd like to ask about the Weekly PA package ($200/wk).");
  const waLink = `https://wa.me/${WA_NUMBER}?text=${waMsg}`;

  return (
    <section id="weekly-pa" style={{
      background: '#fff',
      padding: '3.5rem 0',
    }}>
      <div className="content-column">
        <div className="section-tag">Personal assistant</div>
        <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontWeight: 600,
          fontSize: '1.75rem',
          lineHeight: 1.25,
          color: '#1A1530',
          marginTop: 0,
          marginBottom: '0.85rem',
        }}>
          Your week,{' '}
          <em style={{ fontWeight: 400, color: '#7B6EC4' }}>sorted</em>
        </h2>

        <p style={{
          fontSize: '0.93rem',
          fontWeight: 300,
          color: '#6A6080',
          lineHeight: 1.7,
          marginTop: 0,
          marginBottom: '1.5rem',
          maxWidth: '560px',
        }}>
          For when you want the small stuff handled and your headspace back. Lock in a regular slot, and stop running the whole household in your head.
        </p>

        {/* Price card */}
        <div className="card" style={{ marginBottom: '1.25rem' }}>
          <div style={{
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 600,
            fontSize: '0.85rem',
            color: '#6A6080',
            marginBottom: '0.4rem',
          }}>
            Weekly personal assistant
          </div>
          <div style={{
            fontFamily: "'Playfair Display', serif",
            fontWeight: 600,
            fontSize: '2.25rem',
            color: '#C17A3A',
            lineHeight: 1,
            marginBottom: '0.2rem',
          }}>
            $200
          </div>
          <div style={{
            fontSize: '0.8rem',
            color: '#6A6080',
            marginBottom: '1.25rem',
          }}>
            per week
          </div>

          <div style={{
            fontWeight: 600,
            fontSize: '0.85rem',
            color: '#1A1530',
            marginBottom: '0.6rem',
          }}>
            What's included each week
          </div>

          <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1.25rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {included.map((item) => (
              <li key={item} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', fontSize: '0.85rem', color: '#1A1530', fontWeight: 300 }}>
                <span style={{ color: '#C17A3A', fontWeight: 700, flexShrink: 0, marginTop: '0.05rem' }}>·</span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Customise card */}
        <div style={{
          background: 'linear-gradient(135deg, #F5F2FF, #EDE8FB)',
          border: '0.5px solid #E8E0F0',
          borderRadius: '1.25rem',
          padding: '1.25rem',
          marginBottom: '1rem',
        }}>
          <div style={{
            fontWeight: 600,
            fontSize: '0.9rem',
            color: '#1A1530',
            marginBottom: '0.5rem',
          }}>
            Make it yours
          </div>
          <p style={{
            fontSize: '0.83rem',
            fontWeight: 300,
            color: '#6A6080',
            lineHeight: 1.65,
            margin: '0 0 0.75rem',
          }}>
            Same hours, same price — you decide where they go. Swap any of the included services for:
          </p>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.4rem',
          }}>
            {customise.map((item) => (
              <span key={item} style={{
                background: 'rgba(255,255,255,0.6)',
                border: '0.5px solid #D4CAF0',
                borderRadius: '2rem',
                padding: '0.35rem 0.75rem',
                fontSize: '0.78rem',
                fontWeight: 400,
                color: '#6A6080',
                whiteSpace: 'nowrap',
              }}>
                {item}
              </span>
            ))}
          </div>
        </div>

        {/* Just ask card */}
        <div style={{
          background: 'linear-gradient(135deg, #B8D8F0 0%, #C4BCEE 100%)',
          borderRadius: '1.25rem',
          padding: '1.5rem',
        }}>
          <p style={{
            fontSize: '0.88rem',
            fontWeight: 300,
            color: '#3A3580',
            lineHeight: 1.65,
            marginTop: 0,
            marginBottom: '1.1rem',
          }}>
            If something you need isn't on this list, just ask. Chances are I can sort it, or find someone who can.
          </p>
          <a href={waLink} target="_blank" rel="noopener noreferrer" className="btn-amber">
            Ask about the weekly package
          </a>
        </div>
      </div>
    </section>
  );
}
